<template>
  <div class="container banner">
    <!-- <router-link to="/mustwatch" style="text-decoration:none;"> -->
    <!-- <div class="banner">
      <img class="banner--item" :src="image" alt="banner_full" />
    </div> -->
    <div class="banner-area">
      <figure class="banner--item">
        <img :src="item.image" alt="banner_full" />
      </figure>
      <span class="content-banner">
        <div>
          <h2 class="content-banner--title">{{ item.title }}</h2>
          <p class="content-banner--text">{{ item.text }}</p>
        </div>
        <span class="content-banner--btn" v-show="item.btn == true">
          <button
            style="margin: 10px;"
            class="btn--filter active"
            @click="toggleVisibility('Movies')"
          >
            Top 100 Movies
          </button>
          <button
            class="btn--filter"
            style="margin: 10px;"
            @click="toggleVisibility('Series')"
          >
            Popular TV Shows
          </button>
        </span>
      </span>
    </div>
    <!-- </router-link> -->
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object, required: true }
  },
  methods: {
    toggleVisibility(params) {
      this.$store.commit("EDIT_ITEMS_VISIBILITY_MUSTWATCHED_SHOWS", params);
      params == "Movies" ? (this.movies = true) : (this.movies = false);
      this.$router.push("mustwatch");
    }
  }
};
</script>

<style scoped>
.banner {
  padding-top: 100px;
  display: grid;
  grid-template-columns: 1fr;
  justify-items: stretch;
}
.banner--item {
  padding: 0;
  margin: 0;
  width: 100%;
}

.banner--item > img {
  padding: 0;
  margin: 0;
  width: 100%;
}

.banner-area {
  min-height: 100px;
  display: grid;
  grid-template-columns: 1fr;
  justify-items: stretch;
  position: relative;
  /* border: 1px solid #cdcdcd; */
  border-radius: 15px;
}

.content-banner {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  color: white;
  display: grid;
  grid-template-columns: 40% 50%;
  justify-content: stretch;
  align-items: center;
  row-gap: 5%;
  column-gap: 10%;
}

.content-banner--title {
  align-self: end;
  font-size: 1.8em;
  padding-left: 5%;
  padding: 0;
  margin: 0 5%;
}
.content-banner--text {
  white-space: pre-wrap;
  padding: 0% 6%;
}
.content-banner--text > p {
  padding: 0;
  margin: 0px;
}
.content-banner--btn {
  align-self: end;
  display: grid;
  grid-template-columns: repeat(2, auto);
  justify-content: stretch;
  margin: 0 0 5% 0;
}

.m-4 {
  margin: 0px 4%;
}

.content-banner--text {
  font-size: 0.85em;
}

.content-banner--btn {
  justify-self: center;
}
.btn--filter {
  font-size: 0.85em;
  background: none;
  border: 0px;
  color: white;
  padding: 50;
  margin: 1px;
}
.active {
  background-color: #94c659;
  padding: 10px 10px;
  border-radius: 30px;
}

@media (min-width: 1264px) and (max-width: 1400px) {
  .banner--item {
    width: 100%;
    height: 157px;
  }
  .content-banner {
    grid-template-columns: 50% 40%;
  }
  .content-banner--title {
    font-size: 1.3rem;
    padding-top: 10px;
  }
  .content-banner--text {
    font-size: 0.85em;
  }

  .content-banner--btn {
    justify-self: center;
  }
  .btn--filter {
    background: none;
    border: 0px;
    color: white;
    padding: 0;
    margin: 1px;
  }
  .active {
    background-color: #94c659;
    padding: 7px 5px;
    border-radius: 30px;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .banner--item {
    width: 100%;
    height: auto;
  }
  .content-banner {
    grid-template-columns: 50% 40%;
  }
  .content-banner--title {
    font-size: 0.9em;
    padding-top: 10px;
  }
  .content-banner--text {
    font-size: 0.8em;
  }

  .content-banner--btn {
    justify-self: center;
  }
  .btn--filter {
    background: none;
    border: 0px;
    color: white;
    padding: 0;
    margin: 1px;
  }
  .active {
    background-color: #94c659;
    padding: 7px 5px;
    border-radius: 30px;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .content-banner {
    grid-template-columns: 50% 43%;
    column-gap: 5%;
  }
  .content-banner--title {
    font-size: 0.8em;
    padding-top: 10px;
  }
  .content-banner--text {
    font-size: 0.7em;
  }

  .content-banner--btn {
    justify-self: end;
  }
  .btn--filter {
    background: none;
    border: 0px;
    color: white;
    padding: 0;
    margin: 1px;
  }
  .active {
    background-color: #94c659;
    padding: 7px 5px;
    border-radius: 30px;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .banner--item {
    width: 100%;
    height: auto;
  }
  .content-banner--title {
    font-size: 0.8em;
    padding-top: 10px;
  }
  .content-banner--text {
    font-size: 0.7em;
  }
  .btn--filter {
    background: none;
    border: 0px;
    color: white;
    padding: 0;
    margin: 1px;
  }
  .active {
    background-color: #94c659;
    padding: 7px 5px;
    border-radius: 30px;
  }
}

@media (max-width: 600px) {
  .banner-area {
    min-height: 55px;
  }
  .banner--item {
    width: 100%;
    height: auto;
  }
  .content-banner--title {
    font-size: 0.3em;
    padding-top: 10px;
  }
  .content-banner--text {
    font-size: 5px;
  }
  .content-banner--btn {
    font-size: 0.4em;
  }
  .btn--filter {
    background: none;
    border: 0px;
    color: white;
    padding: 0;
    margin: 1px;
  }
  .active {
    background-color: #94c659;
    padding: 7px 5px;
    border-radius: 30px;
  }
}
</style>
